/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.button {
  padding: 0px;
  background-color: transparent;
  --tw-border-style: none;
  border-style: none;
  cursor: pointer;
}
.items-container {
  z-index: 50;
  position: absolute;
  opacity: 0%;
}
.items {
  max-width: calc(100vw - 2rem);
  background-color: var(--color-theme-surface, white);
  --tw-shadow: 0 0 4px var(--tw-shadow-color, #0000003d);
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-radius: var(--radius-sm, 0.25rem);
  padding: calc(var(--spacing, 0.25rem) * 2);
  display: flex;
  flex-direction: column;
  justify-items: stretch;
  min-width: 235px;
}
.items:focus {
  outline: none;
}
.item {
  display: block;
  gap: calc(var(--spacing, 0.25rem) * 4);
  align-items: center;
  text-align: left;
  padding: calc(var(--spacing, 0.25rem) * 3);
  cursor: pointer;
  border-radius: var(--radius-sm, 0.25rem);
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  color: var(--color-black, #000);
  text-decoration-line: none;
  background-color: transparent;
  --tw-border-style: none;
  border-style: none;
}
.item:not([disabled]) {
  width: 100%;
}
.item[disabled] {
  opacity: 30%;
  cursor: not-allowed;
  pointer-events: none;
}
.item-icon {
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  color: var(--color-emphasis-extra, var(--color-primary-500));
  justify-self: center;
  margin-right: calc(var(--spacing, 0.25rem) * 3);
}
.header {
  cursor: default;
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  color: var(--color-emphasis-medium, #525252);
  margin-top: calc(var(--spacing, 0.25rem) * 2);
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
    }
  }
}
